import React, {Fragment, memo} from 'react';

import {TypeLoc} from 'topmeteo/general/constants';

import Space from './Space';
import Arrows from './Arrows';

const KeyboardControl = ({type}) => (
    <Fragment>
        {type === TypeLoc || <Space />}
        <Arrows type={type} />
    </Fragment>
);

export default memo(KeyboardControl);
